import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { telemetryService } from '@services/api/telemetryService';
import { getSeverityColor, getSeverityLabel } from '@/types/telemetry';
import type { AppEvent } from '@/types/customer';

export const TelemetryEvents = () => {
  const [events, setEvents] = useState<AppEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [severityFilter, setSeverityFilter] = useState<string>('');

  useEffect(() => {
    loadEvents();
  }, [severityFilter]);

  const loadEvents = async () => {
    setLoading(true);
    const result = await telemetryService.getEvents({
      severity: severityFilter as any,
    });
    if (result.success && result.data) {
      setEvents(result.data);
    }
    setLoading(false);
  };

  return (
    <div>
      <h1 className="page-title">Telemetry Events</h1>
      <p className="page-subtitle">Monitor app events, errors, and user journeys</p>

      <div style={{ marginTop: 'var(--spacing-xl)', marginBottom: 'var(--spacing-lg)' }}>
        <select 
          value={severityFilter} 
          onChange={(e) => setSeverityFilter(e.target.value)}
          className="filter-select"
        >
          <option value="">All Severities</option>
          <option value="info">Info</option>
          <option value="warn">Warning</option>
          <option value="error">Error</option>
        </select>
      </div>

      {loading ? (
        <div>Loading events...</div>
      ) : (
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Severity</th>
                <th>Event Type</th>
                <th>Screen</th>
                <th>Action</th>
                <th>User</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.id}>
                  <td className="text-small">{new Date(event.created_at).toLocaleString()}</td>
                  <td>
                    <span className={`status-badge status-${getSeverityColor(event.severity)}`}>
                      {getSeverityLabel(event.severity)}
                    </span>
                  </td>
                  <td className="text-small">{event.event_type}</td>
                  <td className="text-small">{event.screen || '-'}</td>
                  <td className="text-small">{event.action || '-'}</td>
                  <td className="text-small">
                    {event.user_id ? (
                      <Link to={`/customers/${event.user_id}`} className="customer-name-link">
                        {event.user_id.slice(0, 8)}
                      </Link>
                    ) : '-'}
                  </td>
                  <td className="text-small">{event.error_message ? event.error_message.slice(0, 50) + '...' : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

